import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  ProjectOutline,
  BulbOutline,
  TableOutline,
  UserOutline,
  AppstoreOutline,
  HomeOutline,
  GlobalOutline,
  QuestionOutline,
  LogoutOutline,
  GithubOutline,
  GoogleOutline,
  WechatOutline,
  FacebookOutline,
  DingdingOutline,
  PlusOutline,
  ScanOutline,
  DeleteOutline,
  EditOutline,
  HistoryOutline,
  RightOutline,
  DownOutline,
  CloseOutline,
  MoreOutline,
  CheckOutline,
  SearchOutline,
  MoonOutline,
  SunOutline,
  EnvironmentOutline,
  BankOutline,
  ShopOutline,
  FolderOutline,
  ToolOutline,
  SettingOutline,
  SwapOutline,
  LeftOutline,
  TeamOutline,
  ThunderboltOutline,
  AlertOutline,
  FireOutline,
  BugOutline,
  ApartmentOutline,
  HolderOutline,
  FullscreenOutline,
  FullscreenExitOutline,
  BgColorsOutline,
  // 补四个**用到了却没注册**的图标。前三个是项目页（表格与树两版）要的，
  // 第四个是 nz-page-header 那个返回箭头（`nzBackIcon` 的默认值）——
  // 缺了不会渲染成空白，而是抛 `IconNotFoundError` 进控制台（见修订（十八）那次 close-fill）。
  // 补在注册表里而不是改模板：`api` / `hdd` 与表格页是同一个写法，改模板就与那一版不一致了。
  ApiOutline,
  HddOutline,
  MinusOutline,
  ArrowLeftOutline,
  // 项目树那两个悬浮按钮（恢复默认 / 保存布局）要的。这两个与上面四个**缺的后果不一样**，
  // 值得单说：浏览器里它们其实能显示 —— `angular.json` 把 `@ant-design/icons-angular`
  // 那棵 inline-svg 整个拷进了 `assets/`，注册表里没有的图标会去
  // `assets/outline/<名字>.svg` **动态加载**兜底（`assets/outline/rollback.svg` 与
  // `save.svg` 都真实存在）。所以这里补的是**省一次取图标请求**，不是修一个坏图标。
  //
  // 真正非补不可的是**测试**：项目树的挂载用例跑在 jsdom 里，那儿既没有 `assets/`
  // 也没有 `provideHttpClient`，动态加载这条兜底根本走不通。看板没有挂载用例，
  // 所以同样两个图标在那儿一直没暴露这条差异。
  RollbackOutline,
  SaveOutline,
  // 串口调试页（含表头那条串口工具条 `main-uart-bar`）要的。这里**必须**注册，不能指望动态兜底：
  // 未注册的图标在浏览器里会去 `assets/outline/<名字>.svg` 取（见上面那段说明），
  // 但组件的挂载用例跑在 jsdom 里，那儿既没有 `assets/` 也没有 `provideHttpClient`，
  // 会直接抛 `IconNotFoundError`。
  UsbOutline,
  LinkOutline,
  DisconnectOutline,
  ClearOutline,
  PauseOutline,
  CaretRightOutline,
  DownloadOutline,
  CopyOutline,
  SyncOutline,
  SendOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  InfoCircleOutline,
  // 点表列表页表头过滤/排序要的：`caret-up`/`caret-down` 是排序那对箭头，`filter`（fill 主题）
  // 是过滤漏斗。三个都是 **nz-table 自己模板里**渲染的图标（不是我们模板里写的），漏了会走
  // `assets/outline/<名字>.svg` 动态兜底 —— 浏览器里照样显示（见上面 RollbackOutline 那段），
  // 所以这里补的是**省掉每次进点表页的取图标请求**；真正会炸的是以后给这两个页面加挂载用例，
  // jsdom 里既没有 assets 也没有 provideHttpClient，兜底走不通会直接抛 IconNotFoundError。
  CaretUpOutline,
  CaretDownOutline,
  FilterFill,
} from '@ant-design/icons-angular/icons';

export const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  ProjectOutline,
  BulbOutline,
  TableOutline,
  UserOutline,
  AppstoreOutline,
  HomeOutline,
  GlobalOutline,
  QuestionOutline,
  LogoutOutline,
  GithubOutline,
  GoogleOutline,
  WechatOutline,
  FacebookOutline,
  DingdingOutline,
  PlusOutline,
  ScanOutline,
  DeleteOutline,
  EditOutline,
  HistoryOutline,
  RightOutline,
  DownOutline,
  CloseOutline,
  MoreOutline,
  CheckOutline,
  SearchOutline,
  MoonOutline,
  SunOutline,
  EnvironmentOutline,
  BankOutline,
  ShopOutline,
  FolderOutline,
  ToolOutline,
  SettingOutline,
  SwapOutline,
  LeftOutline,
  TeamOutline,
  ThunderboltOutline,
  AlertOutline,
  FireOutline,
  BugOutline,
  ApartmentOutline,
  HolderOutline,
  FullscreenOutline,
  FullscreenExitOutline,
  BgColorsOutline,
  // 见上面 import 处的说明
  ApiOutline,
  HddOutline,
  MinusOutline,
  ArrowLeftOutline,
  RollbackOutline,
  SaveOutline,
  // 见上面 import 处的说明
  UsbOutline,
  LinkOutline,
  DisconnectOutline,
  ClearOutline,
  PauseOutline,
  CaretRightOutline,
  DownloadOutline,
  CopyOutline,
  SyncOutline,
  SendOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  InfoCircleOutline,
  // 见上面 import 处的说明
  CaretUpOutline,
  CaretDownOutline,
  FilterFill,
];
